import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import FormType from '../Form/FormType';
import Utils from '../../utils';
import InputValidator from '../Form/InputValidator';
import ValidatorError from '../Form/ValidatorError';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { CARD_VALUES, SCALAR_TYPE, TARGET_PROPERTY } from '../../constants';
import { getText, TEXT_KEY } from '../../utils/localization';
var SCALAR_TYPES = [SCALAR_TYPE.NUMBER, SCALAR_TYPE.BOOLEAN, SCALAR_TYPE.STRING];

var AutoFormInput = /*#__PURE__*/function (_Component) {
  _inherits(AutoFormInput, _Component);

  var _super = _createSuper(AutoFormInput);

  function AutoFormInput() {
    var _this;

    _classCallCheck(this, AutoFormInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      status: '',
      value: '',
      checked: false,
      cardNickname: '',
      autoCompleteStates: {
        autoCompleteResults: [],
        autoCompleteValue: '',
        autoCompletePayload: {},
        manualAddressThresholdReached: false
      },
      focused: !!_this.props.focused
    };

    _this._inputCompleteHandler = function () {
      var value = _this.props.type === FormType.AUTOCOMPLETE ? _this.state.autoCompleteStates.autoCompletePayload : _this.state.value;
      var isToggle = _this.props.type === FormType.CHECKBOX || _this.props.type === FormType.TOGGLE;

      _this.props.emitInput({
        key: _this.props.id,
        value: isToggle ? _this.state.checked : value,
        validated: isToggle ? _this.state.checked : _this.validateField()
      });
    };

    _this._formChangeHandler = function (value) {
      if (value !== null && value.hasOwnProperty(TARGET_PROPERTY)) {
        value = value.target.value;
      }

      _this.setState({
        value: value
      });
    };

    _this._formFocusHandler = function () {
      _this.setState({
        focused: true
      });
    };

    _this._formBlurHandler = function () {
      _this.setState({
        focused: false
      });
    };

    _this._formToggleHandler = function () {
      _this.setState(function (prevState) {
        return {
          checked: !prevState.checked
        };
      });
    };

    _this._formAutocompleteHandler = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value, item) {
        var newAutoCompleteStates;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (value !== null && value.hasOwnProperty(TARGET_PROPERTY)) {
                  value = value.target.value;
                }

                _this.setState({
                  value: value
                });

                newAutoCompleteStates = _this.state.autoCompleteStates;
                newAutoCompleteStates.autoCompletePayload = {};

                if (value.length > 2 && !_this.state.autoCompleteStates.manualAddressThresholdReached) {
                  newAutoCompleteStates.manualAddressThresholdReached = true;
                }

                if (!(item && item.format)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return _this.assignExperianPayload(item.format, newAutoCompleteStates);

              case 8:
                newAutoCompleteStates = _context.sent;
                _context.next = 18;
                break;

              case 11:
                if (!(item && item.suggestion)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", _this._toggleAutocompleteMode());

              case 15:
                _context.next = 17;
                return _this.handleAutoComplete(value, newAutoCompleteStates);

              case 17:
                newAutoCompleteStates = _context.sent;

              case 18:
                _this.setState({
                  autoCompleteStates: newAutoCompleteStates
                }, _this._inputCompleteHandler());

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleAutoComplete = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value, newAutoCompleteStates) {
        var sanitizedValue, promise, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(value.length >= 5)) {
                  _context2.next = 12;
                  break;
                }

                sanitizedValue = encodeURIComponent(value);
                _context2.next = 4;
                return fetch("https://api.edq.com/capture/address/v2/search?auth-token=".concat(ENVIRONMENT_VARIABLES.EXPERIAN_ENVIRONMENT_KEY, "&query=").concat(sanitizedValue, "&country=AUS"));

              case 4:
                promise = _context2.sent;

                if (!promise.ok) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return promise.json();

              case 8:
                response = _context2.sent;

                if (response.results.length > 0) {
                  newAutoCompleteStates.autoCompleteResults = response.results;
                } else {
                  newAutoCompleteStates.autoCompleteResults = [{
                    suggestion: getText(TEXT_KEY.NO_MATCHES)
                  }];
                }

              case 10:
                _context2.next = 13;
                break;

              case 12:
                if (_this.state.autoCompleteStates.autoCompleteResults.length > 0) {
                  newAutoCompleteStates.autoCompleteResults = [];
                }

              case 13:
                return _context2.abrupt("return", newAutoCompleteStates);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.assignExperianPayload = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(formatUrl, newAutoCompleteStates) {
        var autoCompletePayload, promise;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                autoCompletePayload = {};
                _context3.next = 3;
                return fetch("".concat(formatUrl, "&auth-token=").concat(ENVIRONMENT_VARIABLES.EXPERIAN_ENVIRONMENT_KEY));

              case 3:
                promise = _context3.sent;

                if (!promise.ok) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 7;
                return promise.json();

              case 7:
                autoCompletePayload = _context3.sent;

                if (Object.keys(autoCompletePayload).length > 0) {
                  autoCompletePayload.components.push({
                    manual: false
                  });
                }

              case 9:
                newAutoCompleteStates.autoCompleteResults = [];
                newAutoCompleteStates.autoCompletePayload = autoCompletePayload;
                return _context3.abrupt("return", newAutoCompleteStates);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this._toggleAutocompleteMode = function () {
      var newAutoCompleteStates = _this.state.autoCompleteStates;
      newAutoCompleteStates.autoCompletePayload = {};

      _this.setState({
        value: '',
        autoCompleteStates: newAutoCompleteStates
      });

      _this.props.emitLayoutChange('toggleAutocomplete');
    };

    _this.validateField = function () {
      if (_this.props.validator) {
        var valid = _this.checkValidation(_this.props.validator, _this.state.value);

        if (!valid && !Utils.isEmpty(_this.state.value)) {
          var validatorKey = Object.keys(InputValidator).find(function (key) {
            return InputValidator[key] === _this.props.validator;
          });

          _this.setState({
            status: ValidatorError[validatorKey]
          });
        } else {
          _this.setState({
            status: ''
          });
        }

        return valid;
      }

      return false;
    };

    _this.checkValidation = function (validator, value) {
      return validator(value);
    };

    _this.getFormChangeHandler = function () {
      switch (_this.props.type) {
        case FormType.CHECKBOX:
        case FormType.TOGGLE:
          return _this._formToggleHandler;

        case FormType.AUTOCOMPLETE:
          return _this._formAutocompleteHandler;

        default:
          return _this._formChangeHandler;
      }
    };

    return _this;
  }

  _createClass(AutoFormInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._inputCompleteHandler();

      if (this.props.initialValue) {
        this.setState({
          value: this.props.initialValue
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var defaultValues = [CARD_VALUES.VISA, CARD_VALUES.MASTERCARD, CARD_VALUES.AMEX];

      if (prevState.checked !== this.state.checked || prevState.value !== this.state.value || prevState.autoCompleteStates.autoCompletePayload !== this.state.autoCompleteStates.autoCompletePayload) {
        this._inputCompleteHandler();
      }

      if (prevProps.value !== this.props.value && this.props.value !== this.state.value && SCALAR_TYPES.includes(typeof this.props.value)) {
        this.setState({
          value: this.props.value
        });
      }

      if (prevProps.initialValue && prevProps.initialValue != this.state.value && this.state.cardNickname != this.state.value) {
        if (defaultValues.indexOf(this.state.value) < 0) {
          this.setState({
            value: this.state.value
          });
          this.setState({
            cardNickname: this.state.value
          });
        } else {
          this.setState({
            value: prevProps.initialValue
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isToggle = this.props.type === FormType.CHECKBOX || this.props.type === FormType.TOGGLE;
      return this.props.render(_objectSpread(_objectSpread({}, this.props), {}, {
        showCheckmark: this.props.validator && this.props.validator !== InputValidator.NOT_EMPTY,
        status: this.state.status,
        value: isToggle ? this.state.checked : this.state.value,
        formChangeHandler: this.getFormChangeHandler(),
        autoCompleteStates: this.state.autoCompleteStates,
        toggleAutocompleteMode: this._toggleAutocompleteMode,
        focused: !Utils.isEmpty(this.state.value) || this.props.focused ? true : this.state.focused,
        formFocusHandle: this._formFocusHandler,
        formBlurHandle: this._formBlurHandler
      }));
    }
  }]);

  return AutoFormInput;
}(Component);

AutoFormInput.defaultProps = {
  disabled: false
};
export { AutoFormInput as default };